export default {
    data() {
        return {
            stripeResources: {},
            stripeElement: false,
            stripeEmail: '',
            clientSecret: '',
            publishableKey: "",
            stripeLoading: true,
            stripeScriptIsReady: false,
        }
    },
    created(){
        new Promise((resolve, reject) => {
            const script = document.createElement('script')
            script.onload = () => {
                resolve()
            }
            script.async = true
            script.src = 'https://js.stripe.com/v3/'
            document.head.appendChild(script)
        }).then(() => {
            this.stripeScriptIsReady = true;
        })
    },
    methods: {
        initToken() {
            return new Promise((resolve, reject) => {
                this.$ajax.get(`/rest/stripe/setupintent/init/${this.thirdid}`, {},
                    (response) => {
                        this.clientSecret = response.clientSecret
                        this.publishableKey = response.publishableKey;
                        resolve()
                    },
                    (error) => {
                        Push.error(this.$l10n.__("Une erreur est survenue lors de l'initialisation de Stripe."), false)
                        reject()
                    })
            })
        },
        stripeInit() {
            this.stripeResources.lib = window.Stripe(this.publishableKey);
            this.stripeElement = this.stripeResources.lib.elements()
            this.stripeInitElements();
            this.stripeLoading = false
            this.stripeElement.on('change', function() {
                this.errors.clearAll();
            }.bind(this))
        },
        errorLabel(msg) {
            const labels = {
                // CREDIT CARD
                "invalid_number": this.$l10n.__("Le numéro de carte n'est pas un numéro de carte de crédit valide."),
                "invalid_expiry_month": this.$l10n.__("Le mois d'expiration de la carte n'est pas valide"),
                "invalid_expiry_year": this.$l10n.__("L'année d'expiration de la carte n'est pas valable"),
                "invalid_cvc": this.$l10n.__("Le code de sécurité de la carte n'est pas valide"),
                "incorrect_number": this.$l10n.__("Le numéro de carte est incorrect"),
                "incomplete_number": this.$l10n.__("Le numéro de carte est incomplet"),
                "incomplete_cvc": this.$l10n.__("Le code de sécurité de la carte est incomplet"),
                "incomplete_expiry": this.$l10n.__("La date d'expiration de la carte est incomplète"),
                "expired_card": this.$l10n.__("La carte a expiré"),
                "incorrect_cvc": this.$l10n.__("Le code de sécurité de la carte est incorrect"),
                "incorrect_zip": this.$l10n.__("Le code postal de la carte n'a pas été validé."),
                "invalid_expiry_year_past": this.$l10n.__("L'année d'expiration de la carte est dans le passé"),
                "card_declined": this.$l10n.__("La carte a été refusée"),
                "missing": this.$l10n.__("Il n'y a pas de carte sur le compte d'un client qui fait l'objet d'un débit."),
                "processing_error": this.$l10n.__("Une erreur s'est produite lors du traitement de la carte"),
                // PAYMENT INTENT
                "payment_intent_action_required": this.$l10n.__("Actions requises pour compléter le paiement"),
                "payment_intent_authentication_failure": this.$l10n.__("L'authentification pour le moyen de paiement a échouée"),
                "payment_intent_incompatible_payment_method": this.$l10n.__("Le moyen de paiement est incompatible"),
                "payment_intent_invalid_parameter": this.$l10n.__("Paiement non autorisé"),
                "payment_intent_payment_attempt_failed": this.$l10n.__("Échec lors du paiement"),
                "payment_intent_unexpected_state": this.$l10n.__("Erreur sur le statut du paiement"),
                // error code custom for being more specific
                "payment_intent_unexpected_state_succeeded": this.$l10n.__("Le paiement a déjà été enregistré"),
                "card_declined_insufficient_funds": this.$l10n.__("La carte ne dispose pas de fonds suffisants."),
            }

            return labels[msg] !== undefined ? labels[msg] : this.$l10n.__("Une erreur s'est produite") 
        },
        error(msg) {
            const label = this.errorLabel(msg);

            switch (msg) {
                case 'invalid_expiry_month':
                case 'invalid_expiry_year':
                case 'incomplete_expiry':
                case 'invalid_expiry_year_past':
                case 'expired_card':
                    this.errors.setErrors(Object.assign({ 'card-expiry': label }, this.errors.errors));
                    break;
                case 'invalid_cvc':
                case 'incomplete_cvc':
                case 'incorrect_cvc':
                    this.errors.setErrors(Object.assign({ 'card-cvc': label }, this.errors.errors));
                    break;
                case 'invalid_number':
                case 'incorrect_number':
                case 'incomplete_number':
                case 'card_declined':
                    this.errors.setErrors(Object.assign({ 'card-number': label }, this.errors.errors));
                    break;
            }
        },
        stripeCreateCardToken() { 
            this.errors.clearAll();
            return this.stripeResources.lib.createToken(this.stripeElement)
                .then(response => {
                    if (response.error) {
                        this.error(response.error.code);
                        throw new Error(response.error);
                    }
                    return response.token;
                })
        },
        stripeConfirmPaymentIntent(clientSecret, savePaymentMethod) {
            this.errors.clearAll();
            const paymentMethod = !!this.stripeElement._complete ? {card: this.stripeElement} : this.customerCreditCard.id;

            return this.stripeResources.lib.confirmCardPayment(clientSecret, {
                save_payment_method: !!savePaymentMethod,
                payment_method: paymentMethod
            }).then(response => {
                if (response.error) {
                    let errorCode = response.error.code;
                    // Special case for recognize an already succeeded payment_intent
                    if (errorCode == 'payment_intent_unexpected_state' && response.error.payment_intent.status == 'succeeded') errorCode = 'payment_intent_unexpected_state_succeeded';
                    else if (errorCode == 'card_declined' && response.error.decline_code == 'insufficient_funds') errorCode = 'card_declined_insufficient_funds';
                    this.error(errorCode);
                    throw new Error(errorCode);
                }
                return response;
            })
        }
    },
    watch: {
        stripeScriptIsReady(newV, oldV) {
            if (!newV) return;
            return Promise.all([
                !this.publishableKey ? this.initToken() : null
            ]).then(() => this.stripeInit())
        }
    },
}
